import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { fonts } from '@theme/fontsCustomer';

// StatusBadge: SsoProviderPage, SsoProviderTableRow, SsoProviderDetailPage에서 공통 사용
export const StatusBadge = styled(Box)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0px 5px;
  border-radius: 2px;
  ${fonts.Caption4};

  &.green {
    color: ${({ theme }) => theme.colors['text-green-dark']};
    background: ${({ theme }) => theme.colors['bg-green-lighter']};
    border: 0.5px solid ${({ theme }) => theme.colors['border-gray-lighter']};
  }

  &.red {
    color: ${({ theme }) => theme.colors['text-red-light']};
    background: ${({ theme }) => theme.colors['bg-red-lighter']};
    border: 0.5px solid ${({ theme }) => theme.colors['border-gray-lighter']};
  }
`;

// 모달 폼 공통 스타일: SsoProviderCreateModal, SsoProviderEditModal에서 공통 사용
export const FormBody = styled.form`
  display: flex;
  flex-direction: column;
  padding: 12px 28px 28px;
  max-height: 70vh;
  overflow-y: auto;
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 32px;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RequiredLabel = styled.span`
  ${fonts.Body4};
  color: ${({ theme }) => theme.colors['text-gray-main']};
  &::after {
    content: ' *';
    color: ${({ theme }) => theme.colors['text-red-light']};
  }
`;

export const OptionalLabel = styled.span`
  ${fonts.Body4};
  color: ${({ theme }) => theme.colors['text-gray-main']};
`;

export const ModalButtonBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;

  & > button {
    flex: 1;
  }
`;

// 폼 데이터 타입: CreateModal, EditModal에서 공통 사용
export type SsoProviderFormData = {
  providerName: string;
  issuerUri: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
  scopes: string;
  userNameAttribute: string;
  userInfoUri: string;
};
